import { brand } from '../config/brand';

export default function WhatsAppButton() {
  const number = brand.whatsapp.replace(/\D/g, '');
  if (!number || number === '910000000000') return null;
  return (
    <a
      href={`https://wa.me/${number}?text=${encodeURIComponent('Hi Uclipse, I would like to know more about your products.')}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor">
        <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.385.701 4.6 1.902 6.467L4 29l7.747-1.857A11.94 11.94 0 0 0 16 27c6.627 0 12-5.373 12-12S22.628 3 16.001 3zm6.992 17.187c-.296.831-1.717 1.59-2.394 1.69-.611.09-1.387.128-2.241-.141-.516-.164-1.18-.379-2.029-.741-3.567-1.54-5.897-5.13-6.075-5.367-.178-.237-1.452-1.93-1.452-3.683 0-1.752.92-2.614 1.246-2.97.327-.357.712-.446.95-.446.237 0 .475.002.682.012.218.011.512-.083.8.61.296.712 1.005 2.464 1.094 2.642.089.178.149.386.03.624-.119.237-.179.385-.357.594-.178.208-.375.464-.535.624-.178.178-.364.371-.156.728.208.357.926 1.527 1.989 2.473 1.367 1.218 2.52 1.594 2.876 1.772.357.178.564.149.773-.089.208-.237.892-1.041 1.13-1.398.237-.357.475-.297.802-.178.327.119 2.078.98 2.435 1.158.357.178.594.267.683.416.089.149.089.862-.207 1.694z"/>
      </svg>
    </a>
  );
}
